// extracted by mini-css-extract-plugin
module.exports = {"center":"Align_center__jzRyN","left":"Align_left__34tN-","right":"Align_right__2HZZf","justify":"Align_justify__LwQki"};